const SEARCH_ITEM_TYPES_CONST = {
  INDICATORS: "INDICATORS",
  PUBLICATIONS: "PUBLICATIONS",
  NEWS: "NEWS",
};
export const SEARCH_TYPE_CONST = [
  { typeId: 1, type: SEARCH_ITEM_TYPES_CONST.NEWS },
  { typeId: 2, type: SEARCH_ITEM_TYPES_CONST.PUBLICATIONS },
  { typeId: 3, type: SEARCH_ITEM_TYPES_CONST.INDICATORS },
];
export const getSearchItemUrl = (item) => {
  const itemType = SEARCH_TYPE_CONST.find((att) => att.typeId === item.type);
  if (itemType === undefined) return "";
  if (itemType.type === SEARCH_ITEM_TYPES_CONST.INDICATORS) {
    return `data/mainSubject/${item.mainSubjectId}/subSubject/${item.subSubjectId}/data-visualization/${item.id}`;
  } else if (itemType.type === SEARCH_ITEM_TYPES_CONST.PUBLICATIONS) {
    return `publications/${item.id}`;
  } else if (itemType.type === SEARCH_ITEM_TYPES_CONST.NEWS) {
    return `mediaLanding/news/${item.id}`;
  }
  return "";
};
